module.exports = __webpack_public_path__ + "img/alexandre.c4f8fd38.jpg";